/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TEAM_NAME } from './teamName.constants.tsx';
import { fetchArticleGenerationForTopics as fetchArticleGenerationForTopicsService } from './fetchArticleGenerationForTopics.tsx';

export const triggerArticleGenerationForTopics =
	(projectId: number, analyticsEvent: UIAnalyticsEvent, activationId: string) =>
	async (): Promise<void> => {
		try {
			await fetchArticleGenerationForTopicsService(projectId, activationId);

			fireTrackAnalytics(analyticsEvent, 'triggerArticleGenerationForTopics succeeded', {
				projectId,
			});

			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				meta: {
					id: 'triggerArticleGenerationForTopics',
					packageName: 'jiraServicedeskKnowledgePerformance',
					teamName: TEAM_NAME,
				},
				error,
			});
		}
	};
